import './MarkItem.css'
import { TrashIcon } from '@heroicons/react/24/outline'

function MarkItem({ name, onDelete} ) {
  return (
    <div className='todoitem-box'>
      <label className='checkbox'>
        <input type='checkbox' className='checkbox-input'/>
        <span className='check'></span>
        <span className='todo-text'>{name}</span>
      </label>
      <div onClick={onDelete} >
        <TrashIcon className='trashIcon'/>
      </div>
    </div>
  )
}

export default MarkItem
